import { createStore, combineReducers } from "redux";
import AccessReducer from "./AccessReducer";
import ApplicationReducer from "./ApplicationReducer";
import ImportHealthSafeGoalsReducer from "./ImportHealthSafeGoalsReducer";
import ImportPersonalGoalsReducer from "./ImportPersonalGoalsReducer";
import ImportProfessionalGoalsReducer from "./ImportProfessionalGoalsReducer";
import ImportSocialGoalsReducer from "./ImportSocialGoalsReducer";
import InvoiceApprovalReducer from "./InvoiceApprovalReducer";
import { InvoiceEditApprovalReducer } from "./InvoiceEditApprovalReducer";
import { InvoiceCntForActionReducer } from "./InvoiceForActionCount";
import InvoiceMeetingsReducer from "./InvoiceMeetingsReducer";
import { InvoiceNotesReducer } from "./InvoiceNotesReducer";
import PaymentUpdateReducer from "./PaymentUpdateReducer";
import PCPReducer from "./PCPReducer";
import SPMetadataReducer from "./SPMetadataReducer";
import SPReducer from "./SPReducer";
import UpdatedInvoiceContentReducer from "./UpdatedInvoiceContentReducer";
const isDev = () => {
    return window.location.href.indexOf("localhost") > -1;
}
const productionModeReducer = () => {
    return isDev()
}

const projectdetail = {
    "API": (isDev() ? "https://localhost:7067/api" : "/api"),
    "ProjectName": "Integrated Community Collaborative",
    "ProjectLogo": <img src="../logo.png" className="img-fluid logo" alt="Logo" height="80" />,
    "PoweredBy": "Bow and Baan",
    "PoweredByLink": "https://www.bowandbaan.com/",
    "ErrorMessage": "Something went wrong",
    "maxFileSize": 1048576 * 3,
};

const projectReducer = (detail = projectdetail, actions) => {
    return detail;
}

const rootReducer = combineReducers(
    {
        access: AccessReducer,
        project: ApplicationReducer,
        projectdetail: projectReducer,
        IsDevMode: productionModeReducer,
        pcp: PCPReducer,
        sp: SPReducer,
        spmetadata: SPMetadataReducer,
        impSocialGoal: ImportSocialGoalsReducer,
        impPersonalGoal: ImportPersonalGoalsReducer,
        impProfessionalGoal: ImportProfessionalGoalsReducer,
        impHealthSafeGoal: ImportHealthSafeGoalsReducer,
        updtInvContent: UpdatedInvoiceContentReducer,
        invMeetings: InvoiceMeetingsReducer,
        selPayUpdtData: PaymentUpdateReducer,
        invApproval: InvoiceApprovalReducer,
        invIDNote: InvoiceNotesReducer,
        invIDEditApproval: InvoiceEditApprovalReducer,
        invCntForAction: InvoiceCntForActionReducer,
    }
);
export const store = createStore(rootReducer);
